export const initGallerySlider = () => {
  document.querySelectorAll(".nodetype-content-gallery-slider").forEach((gallery) => {
    const slides = gallery.querySelectorAll(".slides > *");
    const indicators = gallery.querySelectorAll(".bullets > *");
    const prev = gallery.querySelector('.ui [data-nav="bw"]');
    const next = gallery.querySelector('.ui [data-nav="fw"]');

    if (slides.length < 2 || indicators.length < 2 || !prev || !next) return;

    const slidesCount = slides.length;
    const timeout = parseInt(gallery.dataset.autoTransition ?? 0);

    let currentSlide = 0;
    let timer;

    /**
     * Set the current slide or indicator.
     *
     * @param elements slides or indicators
     * @param index slide index
     */
    const setCurrent = (elements, index) => {
      if (isNaN(index)) return;

      elements.forEach((element) => element.classList.remove("current"));
      elements[index].classList.add("current");
    };

    /**
     * Animate to a slide by its index.
     *
     * @param index
     * @param resetInterval
     */
    const animateToSlide = (index, resetInterval) => {
      const nextSlide = {
        fw: () => (currentSlide < slidesCount - 1 ? currentSlide + 1 : 0),
        bw: () => (currentSlide > 0 ? currentSlide - 1 : slidesCount - 1),
      }[index];

      currentSlide = nextSlide?.() ?? (isNaN(index) ? currentSlide : index);

      setCurrent(slides, currentSlide);
      setCurrent(indicators, currentSlide);

      if (resetInterval) {
        clearInterval(timer);

        timer = timeout > 0 ? setInterval(() => animateToSlide("fw"), timeout) : null;
      }
    };

    // Add click listeners to buttons.
    prev.addEventListener("click", () => animateToSlide("bw", true), { passive: true });
    next.addEventListener("click", () => animateToSlide("fw", true), { passive: true });

    // Add click listeners to indicators.
    indicators.forEach((indicator, index) => {
      indicator.addEventListener("click", () => animateToSlide(index, true), { passive: true });
    });

    let touchstartX = 0;
    let touchendX = 0;

    /**
     * Handle the touch gesture.
     */
    const handleGesture = () => {
      if (touchendX < touchstartX) animateToSlide("fw", true);
      if (touchendX > touchstartX) animateToSlide("bw", true);
    };

    gallery.addEventListener("touchstart", (event) => (touchstartX = event.changedTouches[0].screenX), {
      passive: true,
    });

    gallery.addEventListener(
      "touchend",
      (event) => {
        touchendX = event.changedTouches[0].screenX;
        handleGesture();
      },
      { passive: true }
    );

    /**
     * Toggles the timer for auto-slide.
     *
     * @param opt true = on, false = off, null = reset interval if on
     */
    const toggleTimer = (opt = null) => {
      if (timeout <= 0) return;

      // Clear current interval if opt is false.
      if (!opt && timer) window.clearInterval(timer);

      // Set new interval if opt is true and no interval was active, of if opt is null and there was a previous interval.
      if ((opt && !timer) || (opt === null && timer)) timer = setInterval(() => animateToSlide("fw"), timeout);

      // Clear the interval state if opt is false.
      if (!opt && opt !== null) timer = null;
    };

    if (timeout > 0) {
      toggleTimer(true);
      gallery.addEventListener("mouseenter", () => toggleTimer(false), { passive: true });
      gallery.addEventListener("mouseleave", () => toggleTimer(true), { passive: true });
    }
  });
};
